import script from "./BaseSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSearch.vue?vue&type=script&setup=true&lang=js"

import "./BaseSearch.vue?vue&type=style&index=0&id=7945f894&lang=scss"

const __exports__ = script;

export default __exports__